import { On3IconLock } from '@on3/icons';
import clsx from 'clsx';
import { MockDataBar } from 'components/Mock/MockDataBar';

import styles from './GradedSkills.module.scss';

const skills = [
  'size',
  'catch radius',
  'burst / acceleration',
  'route-running',
  'top-end speed',
  'run after catch',
  'ball skills',
  'vertical threat',
  'contested catch',
  'blocking',
];

interface GradedSkillsMockProps {
  className?: string;
}
export const GradedSkillsMock = ({ className }: GradedSkillsMockProps) => {
  return (
    <div className={clsx(styles.scoring, className)}>
      <header>
        <h3>Score</h3>
        <div className={styles.lock}>
          <On3IconLock />
        </div>
      </header>

      <ul>
        {skills.map((skill) => (
          <li key={skill}>
            <span data-type="label">{skill}</span>
            <div data-type="data">
              <MockDataBar />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
